import { useState } from 'react';

interface SetupScreenProps {
  onSubmit: (password: string) => Promise<void>;
  onSkip: () => void;
}

export function SetupScreen({ onSubmit, onSkip }: SetupScreenProps) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 4) {
      setError('Password must be at least 4 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setSubmitting(true);
    try {
      await onSubmit(password);
    } catch (err) {
      setError('Failed to set password. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 'var(--space-4)',
      background: 'var(--color-bg-primary)',
    }}>
      <form onSubmit={handleSubmit} style={{
        maxWidth: 380,
        width: '100%',
        padding: 'var(--space-8)',
        background: 'var(--color-bg-secondary)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)',
      }}>
        <h2 style={{ fontSize: 'var(--font-size-xl)', fontWeight: 'var(--font-weight-bold)', marginBottom: 'var(--space-2)' }}>
          Set App Lock Password
        </h2>
        <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-4)' }}>
          Choose a password to protect your shipment data. There is no recovery mechanism — remember your password.
        </p>
        <div style={{ marginBottom: 'var(--space-3)' }}>
          <label htmlFor="lock-password" style={{ fontSize: 'var(--font-size-sm)', display: 'block', marginBottom: 'var(--space-1)' }}>Password</label>
          <input
            id="lock-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: 'var(--space-2) var(--space-3)', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', background: 'var(--color-bg-primary)', color: 'var(--color-text-primary)', fontSize: 'var(--font-size-base)' }}
            autoFocus
            disabled={submitting}
          />
        </div>
        <div style={{ marginBottom: 'var(--space-3)' }}>
          <label htmlFor="lock-confirm" style={{ fontSize: 'var(--font-size-sm)', display: 'block', marginBottom: 'var(--space-1)' }}>Confirm Password</label>
          <input
            id="lock-confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={{ width: '100%', padding: 'var(--space-2) var(--space-3)', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', background: 'var(--color-bg-primary)', color: 'var(--color-text-primary)', fontSize: 'var(--font-size-base)' }}
            disabled={submitting}
          />
        </div>
        {error && <p style={{ color: 'var(--color-error)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--space-3)' }}>{error}</p>}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={submitting || !password || !confirm}
          style={{ width: '100%', padding: 'var(--space-3)', fontSize: 'var(--font-size-base)', marginBottom: 'var(--space-2)' }}
        >
          {submitting ? 'Setting...' : 'Set Password'}
        </button>
        <button
          type="button"
          className="btn"
          onClick={onSkip}
          style={{ width: '100%', padding: 'var(--space-2)', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}
        >
          Skip
        </button>
      </form>
    </div>
  );
}
